<template>
  <div class="content">
    <div class="logo-container">
      <span class="logo-text">森威管理系统 </span>
      <!-- <img src="@/assets/logo.png" alt="" class="logo" /> -->
      <!-- <span class="logo-text">拍卖</span> -->
    </div>

    <div class="header-container">
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        background-color="#545c64"
        text-color="#fff"
        router
        active-text-color="#fff"
      >
        <template v-for="item in leftMenu" :key="item.id">
          <MenuItem :data="item"> </MenuItem>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MenuItem from "./menu.vue";

export default {
  components: {
    MenuItem,
  },
  mounted() {
    // console.log('加载Aside.vue');
  },
  setup() {
    //所有菜单数据
    let menuObj = [];
    return {
      menuObj,
    };
  },
  computed: {
    ...mapState(["leftMenu"]),
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;

  .logo-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #343a52;
    font-weight: bold;
    font-size: 20px;
    padding-top: 10px;
  }

  .logo {
    display: block;
    width: 45px;
    height: 45px;
    margin-right: 4px;
  }
  .logo-text {
    line-height: normal;
    padding: 10px 18px;
    background-color: rgba(235, 101, 65);
    border-radius: 8px;
    margin-bottom: 12px;
  }

  .el-menu {
    height: 100%;
    border: 0 !important;

    :deep(.el-menu-item-group__title) {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  // 左侧菜单
  .header-container {
    height: calc(100% - 100px);

    :deep(.el-menu) {
      background: #343a52 !important;
      .el-menu-item.is-active {
        color: #fff;
        background-color: #191d2c !important;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 2px;
          height: 100%;
          background-color: #fff;
        }
      }
    }
  }
}

.el-sub-menu__title {
  padding-left: 10px;
}
</style>
